import React from "../../../../_snowpack/pkg/react.js";
import {RowContainer} from "./styles.js";
const DrawnCard = ({suit, value}) => {
  return /* @__PURE__ */ React.createElement(RowContainer, null, /* @__PURE__ */ React.createElement("td", null, `${value} of ${suit}`));
};
export default DrawnCard;
